import { Stack } from "@mui/material";
import dayjs, { Dayjs } from "dayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { resolveUsersDateRange } from "./usersDateDefaults";
import { readOnlyDateInputProps, readOnlyDateInputSx } from "../datePickerReadOnlyInput";

interface UsersFilterItemsProps {
  dateRange: [Dayjs | null, Dayjs | null];
  onDateRangeChange: (range: [Dayjs | null, Dayjs | null]) => void;
}

export default function UsersFilterItems({ dateRange, onDateRangeChange }: UsersFilterItemsProps) {
  // Show the resolved default (last 30 days) rather than a blank field
  // when the user hasn't picked dates yet - see usersDateDefaults.ts.
  const [startDate, endDate] = resolveUsersDateRange(dateRange);
  const today = dayjs();

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Stack direction="row" spacing={2}>
        <DatePicker
          label="Start date"
          value={startDate}
          maxDate={endDate.isBefore(today) ? endDate : today}
          format="DD-MM-YYYY"
          enableAccessibleFieldDOMStructure={false}
          onChange={(value) => onDateRangeChange([value, endDate])}
          slotProps={{
            textField: {
              size: "small",
              color: "secondary",
              inputProps: readOnlyDateInputProps,
              sx: readOnlyDateInputSx,
              "data-tracker": "977",
            } as any,
          }}
        />
        <DatePicker
          label="End date"
          value={endDate}
          minDate={startDate}
          maxDate={today}
          format="DD-MM-YYYY"
          enableAccessibleFieldDOMStructure={false}
          onChange={(value) => onDateRangeChange([startDate, value])}
          slotProps={{
            textField: {
              size: "small",
              color: "secondary",
              inputProps: readOnlyDateInputProps,
              sx: readOnlyDateInputSx,
              "data-tracker": "978",
            } as any,
          }}
        />
      </Stack>
    </LocalizationProvider>
  );
}
